import * as Types from "@constants/ActionTypes";

export const actionLogin = data => {
    return {
        type : Types.LOGIN,
        payload: data
    };
};